import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arabicNumber'
})
export class ArabicNumberPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    var currentLang = localStorage.getItem('lang');
    if (currentLang == "ar") {
      var id= ['۰','۱','۲','۳','٤','۵','٦','۷','۸','۹'];
      return value.toString().replace(/[0-9]/g, function(w){
       return id[+w]
      });
    } else {
      return value;
    }
  }

}
